export enum ProductRouteParams {
  SearchValue = 'searchValue',
  AdvanceSearchType = 'advSearchType',
  AdvanceSearchFilter = 'advSearchFilter',
  ProductDetailKey = 'cin',
  CategoryId = 'categoryId',
  ItemListId = 'itemListId',
  ItemId = 'itemId',
  Gcn = 'gcn',
  SubscriptionCategory = 'SubscriptionCategory'
}
export enum AEMRouteParams {
  Tag = 'tag'
}

